import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../config/environment";
import { BulkUpdateResponse, IssueSyncResponse, LotSyncResponse } from "../models/SyncResults.model";
import { InspectionJobDTO } from "../../../domains/jobs/models/InspectionJobDTO";
import { firstValueFrom } from "rxjs";
import { JobIssueDTO } from "../../../domains/jobIssues/models/IssueDTO";
import { UserVendorContactDTO } from "../../../domains/vendors/models/UserVendorContactDTO";
import { LotAssetDtoSyncable } from "../../../domains/lots/models/LotAssetDto";

@Injectable({
  providedIn: "root"
})
export class DataSyncApiService {

  constructor(private http: HttpClient) { }

  bulkUpdateJobs(jobsToSync: InspectionJobDTO[]): Promise<BulkUpdateResponse> {
    const url = `${environment.backend.apiBaseURL}/api/job/bulkUpdateJobs`;
    return firstValueFrom(this.http.post<BulkUpdateResponse>(url, jobsToSync));
  }

  syncIssues(userVendorContacts: UserVendorContactDTO[], jobIssues: JobIssueDTO[]): Promise<IssueSyncResponse> {
    const url = `${environment.backend.apiBaseURL}/api/job/SyncIssues`;
    const request = {
      userVendorContacts: userVendorContacts || [],
      jobIssues: jobIssues || []
    };
    return firstValueFrom(this.http.post<IssueSyncResponse>(url, request));
  }

  syncLot(lotAssets: LotAssetDtoSyncable[]): Promise<LotSyncResponse> {
    const url = `${environment.backend.apiBaseURL}/api/lot/SyncLot`;
    return firstValueFrom(this.http.post<LotSyncResponse>(url, lotAssets || []));
  }
}